// extracted by mini-css-extract-plugin
export default {"erid":"a54C6RmZ","mobile":"mobile"};